/** @graphql cc **/
import { gql } from 'graphql-tag';

export const ConfluenceSmartCreationModalQuery = gql`
	query ConfluenceSmartCreationModalQuery {
		user: confluence_atlassianUser(current: true) {
			id
			title
		}
	}
`;
